import axios from 'axios';

export default {
    async fetchAll({ filters = {} }) {
        const response = await axios.post('/api/test_results', filters);
        return response.data;
    },
    async fetchByTargetBuildAndTestCase(filters = {}) {
        const response = await axios.get('/api/test_results_for_case_id', { params: filters });
        return response.data;
    },
    async fetchTargetBuildsPlatformsSummary(filters = {}) {
        const response = await axios.get('/api/test_results_platforms_summary', { params: filters });
        return response.data;
    },
    async fetchTestSuiteNames() {
        const response = await axios.get('/api/test_suite_names');
        return response.data;
    },
    async updateIssueUrl(testResultId, issueUrl) {
        const response = await axios.post(`/api/test_results/${testResultId}`, { issue_url: issueUrl });
        return response.data;
    },
    uploadTestResults({ file, name, product, logsUrl }) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", name);
        formData.append("product", product);
        formData.append("logs_url", logsUrl);
        formData.append("build_type", "manual");
        formData.append("mtr", "mtr-manual");
        formData.append("platform", "manual_platform");
        formData.append("ci_service", "ManualUpload");
        return axios.post('/api/upload_xml', formData)
    },
    async checkJiraIssues(testCase) {
        const response = await axios.get('/api/check_jira_issues', { params: {
                test_case_id: testCase,
        }});
        return {
            issues: response.data.issues,
            secondary_issues: response.data.secondary_issues,
            has_issues: response.data.issues.length > 0 || response.data.secondary_issues.length > 0
        };
    },
    async fetchJiraSummary(testCaseIds) {
        const response = await axios.get('/api/jira_summary', { params: {
                test_case_ids: testCaseIds,
            }});
        return response.data.test_cases;
    },
    async fetchFailedTestResultsByTestCase(targetBuildId, testCaseId) {
        const response = await axios.get(`/api/target_builds/${targetBuildId}/failed_test_results`, { params: {
                test_case_id: testCaseId,
            }});
        return response.data.test_results;
    }
}
